import AxiosService from "../../../gateway/rest/AxiosService"

class WebDAVRestService {

    webdavConfigurationEndpoint = '/webdav/configuration'
    webdavPolicyEndpoint = '/webdav/policies'
    webdavTokenizerConfigEndpoint = this.webdavPolicyEndpoint + '/tokenizerconfigs'

    getAll(): Promise<any> {
        return AxiosService.get(this.webdavConfigurationEndpoint)
    }

    create(configuration: any) {
        return AxiosService.post(this.webdavConfigurationEndpoint, configuration)
    }

    update(configuration: any) {
        return AxiosService.put(this.webdavConfigurationEndpoint, configuration)
    }

    delete(id: number) {
        return AxiosService.delete(this.webdavConfigurationEndpoint + '/' + id)
    }

    getAllWebDAVPolicies(): Promise<any> {
        return AxiosService.get(this.webdavPolicyEndpoint)
    }

    createWebDAVPolicy(policy: any): Promise<any> {
        return AxiosService.post(this.webdavPolicyEndpoint, policy)
    }

    getById(id: number): Promise<any> {
        return AxiosService.get(this.webdavPolicyEndpoint + '/' + id)
    }

    deleteWebDAVPolicy(id: number): Promise<any> {
        return AxiosService.delete(this.webdavPolicyEndpoint + '/' + id)
    }

    updateWebServicePolicy(policy: any): Promise<any> {
        return AxiosService.put(this.webdavPolicyEndpoint, policy)
    }

    copyWebServicePolicy(policy: any): Promise<any> {
        return AxiosService.put(this.webdavPolicyEndpoint + '/' + policy.id + '/' + policy.configName)
    }

    addTokenizerConfig(config: any): Promise<any> {
        return AxiosService.post(this.webdavPolicyEndpoint + '/' + config.configId + '/tokenizerconfigs', config)
    }

    updateTokenizerConfig(config: any): Promise<any> {
        return AxiosService.put(this.webdavTokenizerConfigEndpoint, config)
    }

    deleteTokenizerConfig(id: number): Promise<any> {
        return AxiosService.delete(this.webdavTokenizerConfigEndpoint + `/${id}`)
    }

}

export default new WebDAVRestService()
